module.exports = __webpack_public_path__ + "static/media/sign.cc557977.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Img/icon/sign.svg
// module id = 91
// module chunks = 0